import sanitizeHtml from "sanitize-html";

interface FormattedTextProps {
    rawText: string;
    textColor: string;
}

export const FormattedText = (props: FormattedTextProps) => {
    const sanitizedText = sanitizeHtml(props.rawText, {
        allowedTags: ["b", "i", "br"],
        allowedAttributes: {},
    });

    return (
        <p
            className={props.textColor}
            dangerouslySetInnerHTML={{ __html: sanitizedText }}
        />
    );
};
